/* globals $ */
import imagesLoaded from 'imagesloaded';

export default class preloader {
  constructor (cb = null) {
    this.callback = cb;
    this.manifest = $('#master');
    this.init();
  }
  init () {
    this.imageLoad = imagesLoaded(this.manifest);
    this.imageLoad.once('always', $.proxy(this.onLoaded, this));
    //this.imageLoad.on('progress', $.proxy(this.onProgress, this));
    this.imageLoad.once('done', $.proxy(this.onDone, this));
    this.imageLoad.once('fail', $.proxy(this.onFail, this));
  }

  onFail (e) {
    console.log('fail', e);
  }

  onDone (_e) {
    this.clearEvents();
  }

  onLoaded (_e) {
    this.clearEvents();
    $(window).trigger('pageready');
  }

  clearEvents () {
    this.imageLoad.off('always', $.proxy(this.onLoaded, this));
    //this.imageLoad.off('progress', $.proxy(this.onProgress, this));
    this.imageLoad.off('done', $.proxy(this.onDone, this));
    this.imageLoad.off('fail', $.proxy(this.onFail, this));
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/preloader.js